"use client";

import { generateAbbreviation } from "../../lib/util";
import { useFormatCurrency } from "../common/format-currency";
import { getTimeFormatted } from "../common/TimeFormat";
import ImageLoader from "../common/ImageLoader";
import Skeleton from "react-loading-skeleton";

export const TransactionCard = ({
  transactions,
  handleViewMore,
  paymentStatusLabels,
  storePath,
}) => {
  const { formatCurrency } = useFormatCurrency();
  const status = transactions.paymentStatus?.toUpperCase();
  const items = Array.isArray(transactions.paymentItem)
    ? transactions.paymentItem
    : [];

  return (
    <div
      className="transaction-orders"
      onClick={() => handleViewMore(transactions)}
    >
      <div className="order-content">
        {/* Order Info */}
        <div className="order-description">
          <div className="order-description-top">
            <h2>Order Date: {getTimeFormatted(transactions.orderDate)}</h2>
          </div>
          <div className="order-summary">
            <p>
              <strong>Total:</strong>{" "}
              {formatCurrency(transactions.totalAmount, transactions.currency)}
            </p>
            <p>
              <strong>Order No:</strong> {transactions.checkSum}
            </p>
            <p>
              <strong>Delivery Method:</strong> {transactions.deliveryMode}
            </p>
            {storePath === "market-place" && (
              <p>
                <strong>Store:</strong>{" "}
                <span style={{ display: "inline-flex", alignItems: "center" }}>
                  {transactions.host?.name}{" "}
                  {transactions.host?.img ? (
                    <img
                      src={transactions.host.img}
                      alt="Store Logo"
                      style={{
                        width: "30px",
                        height: "30px",
                        marginLeft: "5px",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <Skeleton
                      width={30}
                      height={30}
                      circle
                      style={{ marginLeft: "5px" }}
                    />
                  )}
                </span>
              </p>
            )}
          </div>
        </div>

        {/* View More + Delivery Address */}
        <div className="order-details">
          <span
            style={{
              backgroundColor: paymentStatusLabels[status]?.bg || "#ccc",
            }}
            aria-label={`Order status: ${
              paymentStatusLabels[status]?.label || "Unknown"
            }`}
          >
            {paymentStatusLabels[status]?.label || "Unknown"}
          </span>

          {transactions.deliveryMode === "LOCATION" &&
            transactions.deliveryInfo?.deliveryAddress && (
              <div className="delivery-address">
                <p>
                  <strong>Delivery Address:</strong>
                </p>
                <p>{transactions.deliveryInfo.deliveryAddress}</p>
              </div>
            )}
        </div>
      </div>

      {/* Thumbnails */}
      <div className="order-images">
        {items.length === 0 && <p className="no-items">No items</p>}
        {items.map((item) => {
          // ✅ If no image at all, render abbreviation immediately
          if (!item.mediaThumb) {
            return (
              <div
                key={item.productId}
                className="abbrevated-div"
                style={{
                  width: 50,
                  height: 50,
                  fontSize: "2.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#f0f0f0",
                  borderRadius: "0.25rem",
                  marginRight: "0.5rem",
                  flexShrink: 0,
                }}
                title={item.name}
              >
                {generateAbbreviation(item.name)}
              </div>
            );
          }

          // ✅ If image exists, show skeleton until image is loaded
          return (
            <div
              key={item.productId}
              style={{
                width: 50,
                height: 50,
                position: "relative",
                marginRight: "0.5rem",
                flexShrink: 0,
              }}
            >
              <ImageLoader
                media={item}
                skeletonHeight={50}
                skeletonWidth={50}
                imageStyle={{
                  width: 50,
                  height: 50,
                  objectFit: "cover",
                  borderRadius: "0.25rem",
                  display: "block",
                }}
                alt={item.name}
                width={50}
                height={50}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
